const checkIsNumber = (symbol) => {
  const number = Number(symbol)
  return Number.isInteger(number)
}

export default checkIsNumber
